/** DOM ids used for auto-scroll between flow steps. */
export const BASEBALL_TREND_CONFIG_ANCHOR_ID = "baseball-trend-config";
export const BASEBALL_TREND_PRESETS_ANCHOR_ID = "baseball-trend-presets";
export const BASEBALL_TREND_WARDROBE_ANCHOR_ID = "baseball-trend-wardrobe";
export const BASEBALL_TREND_ACTION_ANCHOR_ID = "baseball-trend-action";
